module.exports = __webpack_public_path__ + "static/media/  (96).49f305eb.jpg";